###@preserve
 * ***.notify.js
 * by Christian Fillies
 * Version: 0.2.14 (8/15/2022)
###

###* Globalized Functions and Prefixes *###
classPrefix = if window._global and _global.css then _global.css else if window.classPrefix then window.classPrefix else 'os'
functionPrefix = if window._global and _global.env then _global.env else if window.functionPrefix then window.functionPrefix else 'os'
attrPrefix = if window._global and _global.attr then _global.attr else if window.attrPrefix then window.attrPrefix else 'os'
notifyFunctionName = 'notify'
notifyFunctionString = functionPrefix + '.' + notifyFunctionName
notifyClassString = classPrefix + '-' + notifyFunctionName
notifyEnv = if typeof window.env == 'function' then if window[env().env] then window[env().env] else window[functionPrefix] else window.rocket
legacy = if window._global and _global.legacysupport then if typeof _global.legacysupport isnt 'string' and _global.legacysupport isnt false then 'rocket' else _global.legacysupport else null
$ = jQuery
if !notifyEnv
  notifyEnv = {}
  window[env().env] = notifyEnv

notify =
  defaults:
    debug: false || if window._global then window._global.debug else false || notifyEnv.debugConsole and notifyEnv.debugConsole()
    type: 'info'
    audio: false
    attributes:
      dateStamp: 'data-' + notifyFunctionName + '-date'
      id: 'data-' + notifyFunctionName + '-id'
    class:
      wrapper: notifyClassString + '-wrapper'
      alert: notifyClassString
      progress: notifyClassString + '-progress'
      header: notifyClassString + '-header'
      headerTitle: notifyClassString + '-header-title'
      headerRight: notifyClassString + '-header-right'
      title: notifyClassString + '-title'
      message: notifyClassString + '-message'
      timestamp: notifyClassString + '-timestamp'
      animated: 'animated'
      fadeIn: 'slideInRight'
      fadeOut: 'fadeOut'
      scrollcontainer: notifyClassString + '-scrollcontainer'
      icon: 'ri'
      iconInfo: 'li-info'
      iconError: 'li-alert'
      iconWarning: 'li-alert'
      iconSuccess: 'li-check'
      iconClose: 'li-close color-fg-inherit'
      iconProgress: 'ri-loading'
      hidden: 'hidden'

  ###* MODIFIERS *###
  id: (length) ->
    Length = length or 24
    id = ''
    charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    i = 0
    while i < Length
      id += charSet.charAt(Math.floor(Math.random() * charSet.length))
      i++
    id
  returnClassSelectors: (x) ->
    classes = x.split(' ')
    defined = =>
      for sel in classes
        '.' + sel
    defined().join('')

  audio: (type) ->
    AudioContext = window.AudioContext or window.webkitAudioContext

    if typeof AudioContext is 'function'
      context = new AudioContext()
      o = context.createOscillator()
      g = context.createGain()
      o.type = 'sine'
      o.frequency.value = 196
      g.gain.setValueAtTime(0.3, context.currentTime)
      if type is 'error' or type is 'warning'
        o.type = 'sine'
        o.frequency.value = 120.31
        o.frequency.exponentialRampToValueAtTime(500, context.currentTime + 0.5)
        g.gain.setValueAtTime(0.3, context.currentTime)

      g.gain.exponentialRampToValueAtTime(0.00001,context.currentTime + 0.5)

      o.connect(g)
      g.connect(context.destination)

      o.start(0)
      o.stop(context.currentTime + 0.5)

  ###* CORE *###
  close: (element) ->
    call = notifyEnv[notifyFunctionName]
    wrapper = document.body.querySelector(call.returnClassSelectors(call.defaults.class.wrapper))

    hide = (el) =>
      if el
        x = el.notify
        el.classList.remove(x.class.fadeIn or call.defaults.class.fadeIn)
        el.classList.add(x.class.animated or call.defaults.class.animated)
        el.classList.add(x.class.fadeOut or call.defaults.class.fadeOut)
        el.style.pointerEvents = 'none'
        el.addEventListener 'webkitAnimationEnd', remove, { once: true }
        el.addEventListener 'animationend', remove, { once: true }
      if x.repeatProgressCall
        clearTimeout x.repeatProgressCall

    remove = ->
      @.remove()
      ## if the wrapper has no more notifications, delete as well
      if !wrapper.hasChildNodes()
        wrapper.remove()

    if event and event.target
      current = event.target.closest(call.returnClassSelectors(call.defaults.class.alert))
    if element
      current = element

    ## remove all
    all = [current]
    if event and event.altKey
      all = Array.from wrapper.querySelectorAll(call.returnClassSelectors(call.defaults.class.alert))

    if !all or !all.length
      remove()
      return false

    if call.defaults.debug
      console.group '%c'+notifyFunctionString+'.close(arguments)', 'font-size:1.2em; margin: .6em 0 0; display: block'
      if event and event.altKey
        console.log 'remove all?', event.altKey
      console.log 'arguments', arguments

    if all and all.length
      for el in all
        hide el

    if call.defaults.debug
      console.log 'current', current
      console.groupEnd()

  progressDone: (x) ->
    call = notifyEnv[notifyFunctionName]
    icon = x.alert.querySelector(call.returnClassSelectors(x.class.iconProgress))
    if icon
      title = x.alert.querySelector(call.returnClassSelectors(x.class.title))
      title.innerHTML += ' complete.'
      x.alert.classList.remove x.class.alert + '-' + x.type
      x.alert.classList.add x.class.alert + '-success'
      icon.classList.remove x.class.iconProgress
      icon.classList.add x.class.iconSuccess

    timeout = =>
      call.close x.alert
    timeOut = 2000
    if x.timeOut is false or x.timeOut is null
      timeOut = false
    if typeof x.timeOut is 'number'
      timeOut = x.timeOut
    if x.debug
      timeOut = 7000
    if timeOut isnt false
      setTimeout timeout, timeOut

  show: ->
    call = notifyEnv[notifyFunctionName]
    args = => Array.from arguments
    settings = call.defaults

    if settings.debug
      console.group '%c'+notifyFunctionString+'.show(arguments)', 'font-size:1.2em; margin: .6em 0 0; display: block'
      console.trace 'arguments', arguments

    for arg, index in args()
      if settings.debug
        console.log 'argument['+index+']', typeof arg
      if typeof arg is 'string'
        settings.message = arg
      if typeof arg is 'object'
        settings = { settings..., arg... }

    if settings.message
      current = call.build settings
      settings.alert = current

      # progress bar

      if window.Pace and settings.progress and typeof settings.progress == 'object' and settings.progress.bar
        percentage = 0
        bar = current.querySelector(call.returnClassSelectors(settings.class.progress)).childNodes[0]
        animate = ->
          percentage = settings.progress.bar.el.childNodes[0].getAttribute('data-progress');
          bar.classList.remove(settings.class.hidden)
          if percentage < 99
            requestAnimationFrame () ->
              animate percentage
            bar.style.transform = 'translate3d('+percentage+'%, 0px, 0px)'
          else
            bar.style.transform = 'translate3d(100%, 0px, 0px)'
            if settings.type is 'progress'
              call.progressDone settings
        current.addEventListener 'webkitAnimationEnd', animate, { once: true }
        current.addEventListener 'animationend', animate, { once: true }

      else

        if !settings.percentage
          settings.percentage = 0
        settings.bar = current.querySelector(call.returnClassSelectors(settings.class.progress)).childNodes[0]

        progress = ->
          clearTimeout settings.repeatProgressCall
          if typeof settings.progress is 'function'
            newpercentage = settings.progress(settings)
            if newpercentage isnt settings.percentage and typeof newpercentage is 'number'
              settings.percentage = newpercentage
          if typeof settings.progress is 'number'
            settings.percentage = settings.progress
          if typeof settings.progress is 'string'
            settings.percentage = window[settings.progress]
          if typeof settings.percentage is 'number'
            if settings.percentage <= 99
              settings.repeatProgressCall = setTimeout progress, 10
            if settings.percentage >= 99
              if settings.type is 'progress'
                call.progressDone settings
          settings.bar.classList.remove(settings.class.hidden)
          settings.bar.style.transform = 'translate3d('+settings.percentage+'%, 0px, 0px)'
        if typeof settings.percentage = 'number'
          progress()
        else
          clearTimeout settings.repeatProgressCall
          if settings.debug
            console.error 'settings.percentage must be of type number'
        current.addEventListener 'webkitAnimationEnd', progress, { once: true }
        current.addEventListener 'animationend', progress, { once: true }

    if settings.debug
      console.log 'settings', settings
      console.groupEnd()

    current

  build: (x) ->
    call = notifyEnv[notifyFunctionName]
    scrollcontainer = document.body.querySelector(call.returnClassSelectors(call.defaults.class.scrollcontainer))
    wrapper = document.body.querySelector(call.returnClassSelectors(call.defaults.class.wrapper))
    date = new Date()
    localDate = date.toLocaleString()
    capitalize = (string) ->
      string.charAt(0).toUpperCase() + string.slice(1)

    ## default properties
    switch x.type
      when 'info' then icon = x.class.iconInfo or call.defaults.class.iconInfo
      when 'progress' then icon = x.class.iconProgress or call.defaults.class.iconProgress
      when 'success' then icon = x.class.iconSuccess or call.defaults.class.iconSuccess
      when 'warning' then icon = x.class.iconWarning or call.defaults.class.iconWarning
      when 'error' then icon = x.class.iconError or call.defaults.class.iconError

    if x.icon
      icon = x.icon

    if x.type
      className = call.defaults.class.alert + '-' + x.type
      type = capitalize(x.type)
      title = type

    if x.className
      className = x.className

    if x.title
      title = x.title

    if x.timeOut isnt false
      switch x.type
        when 'info' then timeOut = 7000
        when 'success' then timeOut = 4000
      if x.type is 'success' and x.debug
        timeOut = 7000

    if typeof x.timeOut is 'number'
      timeOut = x.timeOut

    if x.debug
      console.group '%c'+notifyFunctionString+'.build(arguments)', 'font-size:1.2em; margin: .6em 0 0; display: block'

    if x.type

      newAlertTime = date.getTime()
      alreadyExists = false

      if !scrollcontainer
        scrollcontainer = document.createElement('DIV')
        scrollcontainer.classList.add(call.defaults.class.scrollcontainer)
        document.body.appendChild(scrollcontainer)

      if !wrapper
        wrapper = document.createElement('DIV')
        wrapper.classList.add(call.defaults.class.wrapper)
        scrollcontainer.appendChild(wrapper)

      ## dont fire twice
      prevAlerts = wrapper.querySelectorAll(call.returnClassSelectors(call.defaults.class.alert))
      if prevAlerts and prevAlerts.length
        if newAlertTime is prevAlerts[prevAlerts.length - 1].getAttribute(call.defaults.attributes.dateStamp)
          alreadyExists = prevAlerts[prevAlerts.length - 1]

      if !alreadyExists
        newAlert = document.createElement('DIV')
        newAlert.classList.add(call.defaults.class.alert)
        newAlert.classList.add(className)
        newAlert.classList.add(call.defaults.class.animated)
        newAlert.classList.add(call.defaults.class.fadeIn)
        newAlert.setAttribute(call.defaults.attributes.dateStamp, newAlertTime)
        newAlert.setAttribute(call.defaults.attributes.id, call.id())
        if x.id
          newAlert.id = x.id
        wrapper.appendChild(newAlert)
      alerts = wrapper.querySelectorAll(call.returnClassSelectors(call.defaults.class.alert))
      alerts = Array.from(alerts)

      if alerts
        current = alerts[alerts.length - 1]
        html = """
            <div class="#{x.class.headerRight}">
              <span class="#{x.class.timestamp}">#{localDate}</span>
              <button onclick="#{functionPrefix}.notify.close()"><i class="#{x.class.icon} #{x.class.iconClose}"></i></button>
            </div>
            <div class="#{x.class.header}">
              <i class="#{x.class.icon} #{icon}"></i>
              <span class="#{x.class.headerTitle}">#{type}</span>
            </div>
            <div class="#{x.class.progress}"><div class='#{x.class.hidden}'></div></div>
            <div class="#{x.class.title}">#{title}</div>
          """
        if window._global
          html += """<div class="#{x.class.message} cursor-pointer" onclick="if (window._global) _global.copy(this, { debug: #{x.debug}, plainText: true })">#{x.message}</div>"""
        else
          html += """<div class="#{x.class.message}">#{x.message}</div>"""

        current.innerHTML = html

        if x.after and typeof x.after is 'function'
          after = (event) ->
            event.notify = x
            x.after(event)
          current.addEventListener 'webkitAnimationEnd', after, { once: true }
          current.addEventListener 'animationend', after, { once: true }

        if x.audio and (x.type is 'error' or x.type is 'success' or x.type is 'warning')
          call.audio(x.type)

        current.notify = x

      if timeOut and current
        timeout = =>
          call.close(current)
        setTimeout timeout, timeOut + 3000

    if x.debug
      console.trace 'wrapper', wrapper
      console.log 'current', current
      console.groupEnd()

    current


notifyEnv[notifyFunctionName] = notify.show
for key, val of notify
  notifyEnv[notifyFunctionName][key] = val
if legacy
  notifyEnv.feedbackMessage = notify.show

if typeof window.env is 'function'
  if env(notifyFunctionName).fn
    $.fn[env(notifyFunctionName).fn] = notifyEnv[notifyFunctionName]
  if env(notifyFunctionName).legacyFn
    $.fn[env(notifyFunctionName).legacyFn] = notifyEnv[notifyFunctionName]
else
  $.fn.rocketNotify = notifyEnv[notifyFunctionName]


